export default __webpack_public_path__ + "static/media/aquamarine_teamwork.a00c3f14.svg";